import {defineStore} from "pinia";
import {useCouponStore} from "~/stores/coupon";

export const useDepositStore = defineStore("deposit", () => {
    const couponStore = useCouponStore();
    const isModalOpen = ref(false);
    const transactionId = ref("");

    const toggleModal = function (transaction = null) {
        if (transaction) {
            transactionId.value = transaction;
        }

        isModalOpen.value = !isModalOpen.value;
        couponStore.resetCouponInput();
    };

    return {
        // State
        isModalOpen,
        transactionId,

        // Functions
        toggleModal,
    };
});
